import { Controller } from "@hotwired/stimulus"

// Theme filter for the playlist discovery grid — toggles record-sleeve cards by
// clicking a theme chip. Pure DOM, no fetch (the catalogue is small). Active
// state is tracked with aria-pressed.
//
// Expected markup:
//   <div data-controller="playlist-filter">
//     <button data-theme="all" aria-pressed="true"  data-playlist-filter-target="chip" data-action="playlist-filter#select">All</button>
//     <button data-theme="rainy" aria-pressed="false" data-playlist-filter-target="chip" data-action="playlist-filter#select">Rainy</button>
//     <a data-playlist-filter-target="card" data-theme="rainy">…</a>
//   </div>
export default class extends Controller {
  static targets = ["chip", "card"]

  select(event) {
    const theme = event.currentTarget.dataset.theme

    this.chipTargets.forEach((chip) =>
      chip.setAttribute("aria-pressed", String(chip === event.currentTarget))
    )

    this.cardTargets.forEach((card) => {
      const match = theme === "all" || card.dataset.theme === theme
      card.style.display = match ? "" : "none"
    })
  }
}
